import React from "react";
import ReactDOM from "react-dom";
import Tabs from "./components/tabs";

const rootContainer = document.getElementById("invenio-dynamic-frontpage");

ReactDOM.render(<Tabs />, rootContainer);
